<template>
  <div class="input_input">
    <a-select
      show-search
      :allowClear="true"
      v-model="firmId"
      placeholder="请选择"
      option-filter-prop="children"
      @change="handleChange"
      :filter-option="filterOption"
    >
      <a-select-option v-for="d in userList" :key="d.id">{{ d.name }}</a-select-option>
    </a-select>
  </div>
</template>
  <script>
import { listTenant } from '@/api/system/tenant'

export default {
  name: 'Register',
  components: {},
  data() {
    return {
      firmId: undefined,
      userList: [],
    }
  },
  computed: {},
  created() {
    this.getQi()
  },
  methods: {
    edit(e) {
      console.log(e, '的点点滴滴')

      this.firmId = e
      this.$forceUpdate()
    },
    init() {
      console.log(1122)
      this.firmId = undefined
      this.$forceUpdate()
    },
    // 查询企业品牌
    getQi() {
      const query = {
        pageNum: 1,
        pageSize: 999,
        type: 1,
        status: 0,
      }
      listTenant(query).then((res) => {
        console.log(res, '的点点滴滴')
        this.userList = res.data.records
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 企业品牌
    handleChange(e) {
      console.log(e, '的点点滴滴')
      this.$emit('province', e)
    },
  },
}
</script>